import cubejs from '@cubejs-client/core'
import { LocalStorage } from './utilities/LocalStorage'

const localStorageAPIKey = 'authToken'

export function getCubeAPI(companyId: number) {
  const rootApiUrl = LocalStorage.getOverrideAPIUrl() || process.env.REACT_APP_ROOT_API_URL
  const apiUrl = `${rootApiUrl}/api/v1/company/${companyId}/cube`
  const apiKey = window.localStorage.getItem(localStorageAPIKey) || ''

  return cubejs(apiKey, { apiUrl })
}
